var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isRTL, getSiteLanguage } from '../helpers';
import { editorMode, mobileMode, previewMode, siteMode, SSREnv, } from './constants';
import { BaseEnvironment } from './Base';
var ViewerScriptEnvironment = /** @class */ (function (_super) {
    __extends(ViewerScriptEnvironment, _super);
    function ViewerScriptEnvironment(options) {
        var _this = _super.call(this) || this;
        _this.entry = 'viewerScript';
        var wixAPI = options.wixAPI, appData = options.appData;
        _this.isSSR = wixAPI.window.rendering.env === SSREnv;
        _this.isMobile = wixAPI.window.formFactor === mobileMode;
        _this.isEditor = wixAPI.window.viewMode === editorMode;
        _this.isPreview = wixAPI.window.viewMode === previewMode;
        _this.isViewer = wixAPI.window.viewMode === siteMode;
        _this.language = getSiteLanguage(wixAPI, 'en', _this.isEditor);
        _this.isRTL = isRTL(_this.language);
        _this.multilingual = wixAPI.window.multilingual;
        _this.appDefinitionId = appData.appDefinitionId;
        return _this;
    }
    return ViewerScriptEnvironment;
}(BaseEnvironment));
export { ViewerScriptEnvironment };
//# sourceMappingURL=ViewerScript.js.map